<template>
  <div>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible.value"
      width="30%"
      ref="ruleForm"
      @close="resetForm"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="发生时间" required prop="eventTime">
          <el-date-picker
            v-model="ruleForm.eventTime"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="日期类型" prop="dateType">
          <el-select v-model="ruleForm.dateType">
            <el-option
              :label="item"
              :key="item"
              v-for="item in dateType"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医疗类型" prop="medicalType">
          <el-select v-model="ruleForm.medicalType">
            <el-option
              :label="item"
              :key="item"
              v-for="item in medicalType"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="事件级别" prop="eventLevelId">
          <el-select v-model="ruleForm.eventLevelId">
            <el-option
              :label="item.title"
              :key="item.id"
              v-for="item in eventLevelId"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="不良事件类型" prop="eventTypeId">
          <el-select v-model="ruleForm.eventTypeId">
            <el-option
              :label="item.title"
              :key="item.id"
              v-for="item in eventTypeId"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="患者情况" prop="memberSituation">
          <el-input
            type="textarea"
            v-model="ruleForm.memberSituation"
          ></el-input>
        </el-form-item>
        <el-form-item label="事件基本情况" prop="comment">
          <el-input type="textarea" v-model="ruleForm.comment"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible.value = false"
          >取消</el-button
        >
        <el-button type="primary" @click="submitForm('ruleForm')"
          >立即创建</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import util from "@/utils";
//   import { addAdverseEvent, addAdverseShow } from "@/api";
import { getEvent, dateTypeDict, saveEvent } from "@/api/doctor";
export default {
  name: "adversEvent",
  props: {
    centerDialogVisible: {
      type: Object,
      default: false,
    },
    treatId: {
      type: String,
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      dialogVisible: false,
      eventLevelId: [],
      eventTypeId: [],
      dateType: [],
      medicalType: [],
      ruleForm: {
        // date:'',
        // time: '',
        id: "",
        eventTime: "", // 发生时间
        dateType: "", // 日期类型
        medicalType: "", // 医疗类型
        eventLevelId: "", // 事件级别
        eventTypeId: "", // 不良事件类型
        memberSituation: "", // 患者情况
        comment: "", // 事件基本情况
        orderTreatId: this.treatId, // 举报患者id
      },
      rules: {
        eventTime: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
      },
    };
  },
  watch: {
    centerDialogVisible: {
      handler(val) {
        if (val.value) {
          this.dateTypeDict();
          this.getEvent();
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.centerDialogVisible.value == true) {
      this.dateTypeDict();
      this.getEvent();
    }
  },
  methods: {
    clearValidate(formName) {
      this.$refs[formName].clearValidate();
    },
    // 获取举报患者信息
    async getEvent() {
      const params = {
        orderTreatId: this.treatId,
      };
      const res = await getEvent(params);
      if (res.code == 1) {
        if (res.data) {
          this.ruleForm = res.data;
          this.ruleForm.eventLevelId = Number(res.data.eventLevelId);
        }
      }
    },
    // 下拉框字典
    async dateTypeDict() {
      const res = await dateTypeDict();
      if (res.code == 1) {
        this.dateType = res.data.dateType;
        this.medicalType = res.data.medicalType;
        this.eventLevelId = res.data.eventLevelId;
        this.eventTypeId = res.data.eventTypeId;
      }
    },
    // 关闭弹窗的回调
    resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.ruleForm = {
        eventTime: "", // 发生时间
        dateType: "", // 日期类型
        medicalType: "", // 医疗类型
        eventLevelId: "", // 事件级别
        eventTypeId: "", // 不良事件类型
        memberSituation: "", // 患者情况
        comment: "", // 事件基本情况
        orderTreatId: this.$route.query.treatId, // 举报患者id
      };
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          console.log(this.ruleForm);
          const res = await saveEvent(this.ruleForm);
          if (res.code == 1) {
            this.$message.success("保存成功");
            this.$refs[formName].resetFields();
            this.centerDialogVisible.value = false;
            this.getEvent();
          }
          //   let res = await addAdverseEvent(this.ruleForm);
          //   if (res.success) {
          //     console.log(res);
          //     this.elementTips("success", res.message);
          //     this.$refs[formName].resetFields();
          //   } else {
          //     this.elementTips("warning", res.message);
          //   }
        } else {
          return false;
        }
      });
    },
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    async showType() {
      try {
        const params = {};
        let res = await addAdverseShow(params);
        if (res.success) {
          console.log(res.result);
          this.medicalType = res.result.医疗类吧;
          this.dateType = res.result.日期类型;
          this.eventLevelId = res.result.不良事件等级;
          this.eventTypeId = res.result.不良事件类型;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
